import { date as date_4, equals, compare, now as now_1 } from "../fable_modules/fable-library-js.4.29.0/Date.js";
import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Button, DialogActions, Persona, DialogContent, Caption1, Title3, DialogTitle, DialogBody, DialogSurface, Dialog as Dialog_1, Body1, Caption1Strong, Image, tokens } from "@fluentui/react-components";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { capitalizeFirst } from "../Helpers.jsx";
import { nb } from "date-fns/locale";
import { format as format_3 } from "date-fns";
import { int32ToString, createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { OpenRegular, LocationRegular, CalendarRegular, BookOpenRegular } from "@fluentui/react-icons";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { take, length, exists, empty, append, singleton, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { toArray, defaultArg } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

/**
 * Cross-platform maps URL — opens in Google Maps on web, deep-links to the
 * native Maps app on Android (Google Maps) and iOS (Apple Maps via the
 * browser's open-in-app prompt).
 */
export function mapsUrl(address) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}

function mapsEmbedUrl(address) {
    return `https://maps.google.com/maps?q=${encodeURIComponent(address)}&z=15&output=embed`;
}

function lifecyclePill(event) {
    const now = now_1();
    const pill = (label, fg, bg) => createElement("span", {
        style: {
            display: "inline-flex",
            alignItems: "center",
            padding: ((2 + "px") + " ") + (10 + "px"),
            borderRadius: 12 + "px",
            color: fg,
            backgroundColor: bg,
            fontSize: 12 + "px",
            fontWeight: 600,
        },
        children: reactApi.Children.toArray([label]),
    });
    if (event.Finalized ? true : (compare(event.EndTime, now) <= 0)) {
        return pill("Avsluttet", tokens.colorNeutralForeground3, tokens.colorNeutralBackground3);
    }
    else if (compare(event.Time, now) <= 0) {
        return pill("Pågår", tokens.colorPaletteLightGreenForeground1, tokens.colorPaletteLightGreenBackground2);
    }
    else {
        return defaultOf();
    }
}

function formatWhen(event) {
    const weekday = (d) => {
        let locale, formatOptions;
        return capitalizeFirst((locale = nb, (formatOptions = {}, (formatOptions.locale = locale, format_3(d, "EEEE", formatOptions)))));
    };
    const date_2 = (d_1) => {
        const locale_1 = nb;
        const formatOptions_1 = {};
        formatOptions_1.locale = locale_1;
        return format_3(d_1, "d. MMMM yyyy", formatOptions_1);
    };
    const time = (d_2) => {
        const locale_2 = nb;
        const formatOptions_2 = {};
        formatOptions_2.locale = locale_2;
        return format_3(d_2, "HH:mm", formatOptions_2);
    };
    if (equals(date_4(event.Time), date_4(event.EndTime))) {
        return `${weekday(event.Time)} ${date_2(event.Time)}, ${time(event.Time)}–${time(event.EndTime)}`;
    }
    else {
        return `${weekday(event.Time)} ${date_2(event.Time)}, ${time(event.Time)} – ${weekday(event.EndTime)} ${date_2(event.EndTime)}, ${time(event.EndTime)}`;
    }
}

function Hero(event) {
    let elems, el_2;
    const matchValue = event.Course.ImageUrl;
    let matchResult, url_1;
    if (matchValue != null) {
        if (!isNullOrWhiteSpace(matchValue)) {
            matchResult = 0;
            url_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const el = Image;
            return createElement(el, {
                style: {
                    display: "block",
                    width: 100 + "%",
                    height: 180,
                    objectFit: "cover",
                },
                src: url_1,
                fit: "cover",
            });
        }
        default:
            return createElement("div", createObj(ofArray([["style", {
                height: 180,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: tokens.colorNeutralBackground3,
            }], (elems = [(el_2 = BookOpenRegular, createElement(el_2, {
                style: {
                    fontSize: 96 + "px",
                },
                primaryFill: tokens.colorNeutralForeground3,
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

function SectionEyebrow(sectionEyebrowInputProps) {
    const label = sectionEyebrowInputProps.label;
    const el = Caption1Strong;
    return createElement(el, {
        style: {
            display: "block",
            textTransform: "uppercase",
            letterSpacing: "0.6px",
            color: tokens.colorNeutralForeground3,
            marginTop: 4,
        },
        children: label,
    });
}

function DetailRow(detailRowInputProps) {
    let elems_1, el;
    const text = detailRowInputProps.text;
    const icon = detailRowInputProps.icon;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 10 + "px ",
    }], (elems_1 = [createElement("div", {
        style: {
            color: tokens.colorBrandForeground1,
            display: "flex",
            flexShrink: 0,
        },
        children: reactApi.Children.toArray([icon]),
    }), (el = Body1, createElement(el, {
        children: text,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function Dialog(dialogInputProps) {
    let elems_15, el_38, elems_14, elemsToUse;
    const onClose = dialogInputProps.onClose;
    const selected = dialogInputProps.selected;
    const el_40 = Dialog_1;
    return createElement(el_40, createObj(ofArray([["open", selected != null], ["modalType", "modal"], ["onOpenChange", (_arg, value_1_1) => {
        if (!value_1_1.open) {
            onClose();
        }
    }], (elems_15 = [(el_38 = DialogSurface, createElement(el_38, createObj(ofArray([["style", {
        maxWidth: 560,
        padding: 0,
        display: "flex",
        flexDirection: "column",
    }], (elems_14 = toList(delay(() => {
        let el_36, elems_13, el_4, elems_2, elems_1, elems, el, el_2, el_28, elems_10, elems_9, el_34, elems_12, elems_11, el_30, el_32;
        if (selected != null) {
            const event = selected;
            return singleton((el_36 = DialogBody, createElement(el_36, createObj(singleton_1((elems_13 = [(el_4 = DialogTitle, createElement(el_4, createObj(singleton_1((elems_2 = [createElement(Hero, event), createElement("div", createObj(ofArray([["style", {
                padding: ((16 + "px ") + 18) + "px",
                gap: 12 + "px ",
                display: "flex",
                flexDirection: "column",
                gap: 4 + "px ",
            }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
                gap: 8 + "px ",
                flexWrap: "wrap",
            }], (elems = [(el = Title3, createElement(el, {
                children: event.Name,
            })), lifecyclePill(event)], ["children", reactApi.Children.toArray(Array.from(elems))])]))), (el_2 = Caption1, createElement(el_2, {
                style: {
                    display: "block",
                    color: tokens.colorNeutralForeground3,
                },
                children: event.Course.Name,
            }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))]))))), (el_28 = DialogContent, createElement(el_28, createObj(singleton_1((elems_10 = [createElement("div", createObj(ofArray([["style", {
                padding: ((16 + "px ") + 18) + "px",
                display: "flex",
                flexDirection: "column",
                gap: 18 + "px ",
            }], (elems_9 = toList(delay(() => {
                let elems_6;
                return append(singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    gap: 14 + "px ",
                }], (elems_6 = toList(delay(() => append(singleton(createElement(SectionEyebrow, {
                    label: "Arrangement",
                })), delay(() => {
                    let el_6;
                    return append(singleton(createElement(DetailRow, {
                        icon: (el_6 = CalendarRegular, createElement(el_6, {
                            fontSize: 20,
                        })),
                        text: formatWhen(event),
                    })), delay(() => {
                        let elems_4, elems_3, el_8, el_10, el_12;
                        return append((event.Address.length > 0) ? singleton(createElement("a", createObj(ofArray([["href", mapsUrl(event.Address)], ["target", "_blank"], ["rel", "noopener noreferrer"], ["style", {
                            display: "flex",
                            alignItems: "center",
                            gap: 10 + "px ",
                            textDecoration: "none",
                            color: tokens.colorNeutralForeground1,
                        }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
                            color: tokens.colorBrandForeground1,
                            display: "flex",
                            flexShrink: 0,
                        }], (elems_3 = [(el_8 = LocationRegular, createElement(el_8, {
                            fontSize: 20,
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), (el_10 = Body1, createElement(el_10, {
                            children: event.Address,
                        })), (el_12 = OpenRegular, createElement(el_12, {
                            style: {
                                fontSize: 14 + "px",
                                color: tokens.colorNeutralForeground3,
                            },
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : empty(), delay(() => {
                            let elems_5;
                            return append((event.Address.length > 0) ? singleton(createElement("div", createObj(ofArray([["style", {
                                display: "flex",
                                flexDirection: "column",
                                gap: 8 + "px ",
                            }], (elems_5 = [createElement("iframe", {
                                src: mapsEmbedUrl(event.Address),
                                title: "Kart",
                                style: {
                                    width: 100 + "%",
                                    height: 200,
                                    border: (((0 + "px ") + "none") + " ") + "transparent",
                                    borderRadius: tokens.borderRadiusMedium,
                                },
                                loading: "lazy",
                                referrerPolicy: "no-referrer-when-downgrade",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))) : empty(), delay(() => {
                                let el_14;
                                return append(singleton((el_14 = Persona, createElement(el_14, {
                                    name: `${event.Teacher.FirstName} ${event.Teacher.LastName}`,
                                    secondaryText: "Kursholder",
                                    size: "medium",
                                    avatar: {
                                        color: "colorful",
                                        image: {
                                            src: defaultArg(event.Teacher.ThumbnailUrl, ""),
                                        },
                                    },
                                }))), delay(() => {
                                    let el_16;
                                    return append((event.Summary.length > 0) ? singleton((el_16 = Body1, createElement(el_16, {
                                        children: event.Summary,
                                    }))) : empty(), delay(() => {
                                        let el_18, d_1;
                                        const matchValue = event.Description;
                                        let matchResult, d_2;
                                        if (matchValue != null) {
                                            if ((d_1 = matchValue, d_1.length > 0)) {
                                                matchResult = 0;
                                                d_2 = matchValue;
                                            }
                                            else {
                                                matchResult = 1;
                                            }
                                        }
                                        else {
                                            matchResult = 1;
                                        }
                                        switch (matchResult) {
                                            case 0:
                                                return singleton((el_18 = Caption1, createElement(el_18, {
                                                    style: {
                                                        display: "block",
                                                        color: tokens.colorNeutralForeground2,
                                                    },
                                                    children: d_2,
                                                })));
                                            default: {
                                                return empty();
                                            }
                                        }
                                    }));
                                }));
                            }));
                        }));
                    }));
                })))), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                    let matchValue_1, dateDescription, elems_7, el_20, el_22;
                    return append((matchValue_1 = event.DateDescription, (matchValue_1 == null) ? (empty()) : ((dateDescription = matchValue_1, singleton(createElement("div", createObj(ofArray([["style", {
                        borderTop: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
                        paddingTop: 8,
                    }], (elems_7 = [(el_20 = Caption1Strong, createElement(el_20, {
                        style: {
                            display: "block",
                            textTransform: "uppercase",
                            letterSpacing: 0.5 + "px",
                            color: tokens.colorNeutralForeground3,
                        },
                        children: "Tidsoversikt",
                    })), (el_22 = Body1, createElement(el_22, {
                        style: {
                            whiteSpace: "pre-wrap",
                        },
                        children: dateDescription,
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))))))), delay(() => {
                        let elems_8;
                        return ((event.Course.Summary.length > 0) ? true : exists((d_3) => (d_3.length > 0), toArray(event.Course.Description))) ? singleton(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexDirection: "column",
                            gap: 8 + "px ",
                            paddingTop: 14,
                            borderTop: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
                        }], (elems_8 = toList(delay(() => append(singleton(createElement(SectionEyebrow, {
                            label: "Om kurset",
                        })), delay(() => {
                            let el_24;
                            return append((event.Course.Summary.length > 0) ? singleton((el_24 = Body1, createElement(el_24, {
                                children: event.Course.Summary,
                            }))) : empty(), delay(() => {
                                let el_26, d_4;
                                const matchValue_2 = event.Course.Description;
                                let matchResult_1, d_5;
                                if (matchValue_2 != null) {
                                    if ((d_4 = matchValue_2, d_4.length > 0)) {
                                        matchResult_1 = 0;
                                        d_5 = matchValue_2;
                                    }
                                    else {
                                        matchResult_1 = 1;
                                    }
                                }
                                else {
                                    matchResult_1 = 1;
                                }
                                switch (matchResult_1) {
                                    case 0:
                                        return singleton((el_26 = Caption1, createElement(el_26, {
                                            style: {
                                                display: "block",
                                                color: tokens.colorNeutralForeground2,
                                            },
                                            children: d_5,
                                        })));
                                    default: {
                                        return empty();
                                    }
                                }
                            }));
                        })))), ["children", reactApi.Children.toArray(Array.from(elems_8))])])))) : empty();
                    }));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_10))]))))), (el_34 = DialogActions, createElement(el_34, createObj(ofArray([["style", {
                width: 100 + "%",
                display: "flex",
                gridColumnStart: 1,
                gridColumnEnd: 3,
                padding: ((0 + "px ") + 16) + "px",
            }], (elems_12 = [createElement("div", createObj(ofArray([["style", {
                padding: ((18 + "px ") + 0) + "px",
                borderTop: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
                backgroundColor: tokens.colorNeutralBackground1,
                justifyContent: "flex-end",
                display: "flex",
                width: 100 + "%",
                boxSizing: "border-box",
                gap: 8 + "px ",
                flexShrink: 0,
            }], (elems_11 = [(el_30 = Button, createElement(el_30, {
                appearance: "secondary",
                children: "Lukk",
                onClick: (_arg_1) => {
                    onClose();
                },
            })), (el_32 = Button, createElement(el_32, {
                appearance: "primary",
                children: "Åpne arrangement",
                onClick: (_arg_2) => {
                    onClose();
                    RouterModule_nav(ofArray(["arrangement", int32ToString(event.Id)]), 1, 1);
                },
            }))], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_12))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_13))]))))));
        }
        else {
            return singleton(defaultOf());
        }
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_14))])]))))], (elemsToUse = ((length(elems_15) <= 2) ? elems_15 : take(2, elems_15)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

//# sourceMappingURL=EventViewDialog.jsx.map
